import React from "react";
import { languageService } from "../../../Language/language.service";

export const TableCellScrollable = (d) => <div style={{ whiteSpace: "break-spaces", overflowY: "auto" }}>{languageService(d.value)}</div>;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/Helper/TableUtils.js